<div *ngIf="isWebshop">
    {{ address.companyName }}
</div>
<div *ngIf="!isWebshop">
    {{ address | fullName }} <br />
    {{ address | shortUserAddress }} <br />
    <span [class]="countryFlag"></span> {{ address.country }}
</div>
